import React from "react";
import { useFormikContext } from "formik";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
const CreditCard = () => {
  const { values} = useFormikContext<any>();
  const month = values?.expiration?.slice(0, 2);
  const year = values?.expiration?.slice(5, 7);

  return (
    <div>
      <Cards
        number={values?.number}
        expiry={`${month}/${year}`}
        cvc={values?.cvv}
        name={values?.holderName}
        focused={""}
        placeholders={
          {name:"Seu nome aqui", }
        }
        locale={{
          valid: "Validade"
        }}
      />
    </div>
  );
};

export default CreditCard;